import React, { useState } from "react";
import PropTypes from "prop-types";
import classes from "./StudentMyLessonCard.module.css";
import Fonts from "../assets/Fonts";
import Colors from "../assets/Colors";
import { Button } from "../Button/Button";
import {
  LocationIconGray,
  CalendarIconGray,
  ClockIconGray,
  coachDemoImg,
  FlagIconBlack,
  CancelIconBlack,
  SendIconBlue,
  ChatBlackIcon,
} from "../../constant/imagePath";
import { Tooltip } from "../Tooltip/index";
import { InputWithButton } from "../InputWithButton/InputWithButton";

export const StudentMyLessonCard = ({ data, onClick1, onClick2 }) => {
  const [isReply, setIsReply] = useState(false);
  const [reply, setReply] = useState();

  return (
    <div className={classes.cardContainer}>
      <div
        className={`${[classes.card].join(" ")}`}
        style={{ borderColor: Colors.neutralShadesOfWhisper }}
      >
        <style jsx>{`
          .tooltip-inner {
            padding: 8px;
            color: #fff;
            background-color: #222222;
            border-radius: 10px;
          }
        `}</style>

        <div className={`${[classes.profile].join(" ")}`}>
          <img src={data?.userData?.profile} />
        </div>
        <div className={`ms-4 ${[classes.contentBox].join("")}`}>
          <div className={` ${[classes.header].join("")}`}>
            {/* Card Heading */}
            <div className={classes.headings}>
              <h5
                style={{
                  ...Fonts.h5,
                  color: Colors.neutralShadesOfNero,
                }}
              >
                {data?.requestType}
              </h5>{" "}
              <h5
                className={`${[classes.heading].join(" ")}`}
                style={{
                  ...Fonts.h5,
                  color: Colors.neutralShadesOfNero,
                }}
              >
                with {data?.userData?.displayName}
              </h5>
            </div>
            {/* Card Buttons */}
            <div>
              {data?.type === "pending" && (
                <div className="d-flex">
                  <Tooltip
                    position="bottom"
                    text={"decline"}
                    className={classes?.iconBtnTooltipContainer}
                  >
                    <Button
                      customStyle={{
                        color: Colors.neutralShadesOfNero,
                        ...Fonts.b2,
                        padding: "12px",
                      }}
                      icon={CancelIconBlack}
                      onClick={onClick1}
                    />
                  </Tooltip>
                  <Button
                    label={"Accept"}
                    customStyle={{
                      ...Fonts.b2,
                      padding: "14px 24px",
                      border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                    }}
                    primary={true}
                    onClick={onClick2}
                  />
                </div>
              )}

              {data?.type === "accepted" && (
                <div className="d-flex">
                  <Tooltip
                    position="bottom"
                    text={"message"}
                    className={classes?.iconBtnTooltipContainer}
                  >
                    <Button
                      customStyle={{
                        color: Colors.neutralShadesOfNero,
                        ...Fonts.b2,
                        padding: "12px",
                      }}
                      icon={ChatBlackIcon}
                      onClick={onClick1}
                    />
                  </Tooltip>

                  <Button
                    label={"Cancel"}
                    customStyle={{
                      ...Fonts.b2,
                      padding: "14px 24px",
                      border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                    }}
                    primary={false}
                    onClick={onClick2}
                  />
                </div>
              )}
              {data?.type === "last-visited" && (
                <div className="d-flex">
                  <Tooltip
                    position="bottom"
                    text={"report"}
                    className={classes?.iconBtnTooltipContainer}
                  >
                    <Button
                      customStyle={{
                        color: Colors.neutralShadesOfNero,
                        ...Fonts.b2,
                        padding: "12px",
                      }}
                      icon={FlagIconBlack}
                      onClick={onClick1}
                    />
                  </Tooltip>

                  <Button
                    label={"Evaluate"}
                    customStyle={{
                      ...Fonts.b2,
                      padding: "14px 24px",
                      border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                    }}
                    primary={false}
                    onClick={onClick2}
                  />
                </div>
              )}

              {data?.type === "evaluate" && (
                <Button
                  customStyle={{
                    ...Fonts.b2,
                    padding: "14px 24px 14px 24px",
                    minWidth: "136px",
                    height: "48px",
                  }}
                  onClick={onClick1}
                  primary={true}
                  label={"Evaluate"}
                />
              )}
              {data?.type === "read-evaluation" && (
                <div className="d-flex">
                  <Button
                    customStyle={{
                      ...Fonts.b2,
                      padding: "14px 24px 14px 24px",
                      minWidth: "136px",
                      height: "48px",
                    }}
                    label={"Read evaluation"}
                  />
                </div>
              )}
            </div>
          </div>
          {/* Center Border */}
          <p className={` ${[classes.halfBorder].join(" ")}`} />
          {/* Main Content */}
          <div className={classes.lastLine}>
            <div>
              <ul>
                <li
                  style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}
                >
                  <img src={CalendarIconGray} />
                  <span
                    style={{ ...Fonts.p2, color: Colors.neutralShadesOfNero }}
                  >
                    {data?.date}
                  </span>
                </li>
                <li
                  style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}
                >
                  <img src={ClockIconGray} />
                  <span
                    style={{ ...Fonts.p2, color: Colors.neutralShadesOfNero }}
                  >
                    {data?.time}
                  </span>
                </li>
                <li
                  style={{
                    ...Fonts.p2,
                    color: Colors.neutralShadesOfDimGray,
                  }}
                >
                  <img src={LocationIconGray} />
                  <span
                    style={{ ...Fonts.p2, color: Colors.neutralShadesOfNero }}
                  >
                    {data?.location}
                  </span>
                </li>
              </ul>
            </div>
            {data?.timeLeft && (
              <p
                className={classes.time}
                style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}
              >
                {data?.timeLeft} left
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

StudentMyLessonCard.propType = {
  userData: PropTypes.object,
  time: PropTypes.string,
  date: PropTypes.string,
  location: PropTypes.string,
  income: PropTypes.string,
  timeLeft: PropTypes.string,
  type: PropTypes.string,
  requestType: PropTypes.string,
  onClick1: PropTypes.func,
  onClick2: PropTypes.func,
};
StudentMyLessonCard.defaultProps = {
  data: {
    userData: {
      displayName: "Tyler",
      profile: coachDemoImg,
    },
    date: "Aug 27,2021",
    time: "12:30PM-2:30Pm",
    location: "DeWitt Clinton Park, W54thy St, New York, NY",
    type: "pending",
    income: "$64",
    requestType: "1-on-1 Tennis Lesson",
    timeLeft: "6 days",
  },
};
